/**
 * bse bootstrap enhanced library v1.1.2
 *
 */
$(function(){

	// bse implements toggling button when clicking parent or other element
	// der Button muss innerhalb des Containers liegen
	// Todo: noch Unterstuetzung fuer <button> implementieren (closest form suchen und action auslesen usw...)
	// USAGE EXAMPLE:
	// <div class="container" data-bse-toggle="button" data-bse-target="#shop-block-with-button-somewhere-inside"> ...
	// Parameter:
	// bse-toggle = button

	$('*[data-bse-toggle]').each(function(){
		var self = $(this),
			mode = self.data('bse-toggle'),
			target = self.find(self.data('bse-target')),
			openMode = target.attr('target');
		switch (mode) {
			case 'button':
				target.on('click', function(e){
					e.stopPropagation();
				});
				self
					.css('cursor','pointer')
					.on('click', function(e){
						if (openMode==='_blank') {
							window.open( target.attr('href'), '_blank' );
						} else {
							document.location.href = target.attr('href');
						}
					})
				;

			default:
				return;
		}
	});

});
